import React from "react";
import { Table, Button, Popconfirm, Space } from "antd";
import validarpermiso from "../../../lib/utils";

const BodegasTable = ({
  bodegas,
  loading,
  pagination,
  handleTableChange,
  showModal,
  handleDelete,
  permisos
}) => {
  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => (
        <Space>
          {validarpermiso("bodegas", "update", permisos) && (
            <Button 
              type="primary" 
              onClick={() => showModal(record)}
            >
              Editar
            </Button>
          )}
          {validarpermiso("bodegas", "delete", permisos) && (
            <Popconfirm
              title="¿Estás seguro de eliminar esta bodega?"
              onConfirm={() => handleDelete(record.id)}
              okText="Sí"
              cancelText="No"
            >
              <Button type="primary" danger>
                Eliminar
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Table
      dataSource={bodegas}
      columns={columns}
      rowKey="id"
      loading={loading}
      pagination={pagination}
      onChange={handleTableChange}
    />
  );
};

export default BodegasTable;